"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouteLink = void 0;
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var RoutePreloaderContext_1 = require("../RoutePreloaderContext");
var RouteLink = function (_a) {
    var path = _a.path, params = _a.params, children = _a.children, rest = __rest(_a, ["path", "params", "children"]);
    var routeToComponentMap = (0, react_1.useContext)(RoutePreloaderContext_1.RoutePreloaderContext);
    var LazyComponent = routeToComponentMap[path.replace(/^\//, "")];
    console.info("RouteLink", routeToComponentMap, LazyComponent);
    var timeoutId = (0, react_1.useRef)();
    var onStartIntent = (0, react_1.useCallback)(function () {
        timeoutId.current = setTimeout(function () {
            console.info(LazyComponent);
            if (LazyComponent.preload) {
                console.info("LazyComponent.preload()", LazyComponent.preload());
            }
        }, 500);
    }, []);
    var onEndIntent = (0, react_1.useCallback)(function () {
        if (timeoutId.current) {
            clearTimeout(timeoutId.current);
        }
    }, []);
    return (react_1.default.createElement(react_router_dom_1.NavLink, __assign({ onMouseLeave: onEndIntent, onMouseEnter: onStartIntent }, rest, { to: (0, react_router_dom_1.generatePath)(path, params) }), children));
};
exports.RouteLink = RouteLink;
exports.default = exports.RouteLink;
